<template>
    <div class="TAYLayout" style="min-height:100vh" ref="content" v-if="UserPrivateProfile.UserId">

        <div style="touch-action:none;">
            <div class="navbar navbar-light navbar-expand-md navigation-clean" style="z-index:2;display:inline-flex; width:100vw;">
                <div v-if="IsMobile">
                    <font-awesome-icon :icon="['fa', 'bars']" @click="CloseSlideout()" />
                </div>
                <font-awesome-icon v-if="!IsMobile" :icon="['fa', 'bars']" id="HamburgerMenuDesktop" @click="HamburgerMenuDesktop()" class="pointer" />
                <a id="navbar-brand" class="navbar-brand pointer"><router-link to="/"><img v-bind:src="sitelogo" /></router-link></a>

            </div>
        </div>
        <div>
            <b-row no-gutters>
                <b-col cols="2" :class="IsMobile ? 'sidebar' : 'sidebarColumn paper side-tabs'" :style="[IsMobile ? sidebarStyle : {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content','display' : 'block'}]" ref="sidebarColumn">
                    <div :class="IsMobile? 'slideout-menu sidebarColumn' : 'sidebar'" style="slideout-left-menu">
                        <Slideout  @hook:mounted="$refs.Slideout.slideout.disableTouch()" v-if="IsMobile" menu="#menu" panel="#panel" :padding="innerWidth * 0.7" ref="Slideout" @on-open="sidebarStyle = {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content'}" @on-close="sidebarStyle = {'display':'none'}" @on-translatestart="sidebarStyle = {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content'}" />
                        <div :class="IsMobile ? 'mobile-name-style' : 'display-none'">
                            <div> {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</div>
                        </div>
                        <b-nav :id="IsMobile ? 'menu' : 'desktop'" tabs vertical>
                          
                            <span v-for="(item, index) in SideBarItems" class="MobileActiveStyle">
                                <!--Does not have a drop down-->
                                <b-nav-item  @click="CloseSlideout()" v-if="Object.keys(item.DropDownList).length < 1 && CheckPermission(item.Permission) " v-on:click="ChangePaneShown(item.Name)" v-bind:class="{ active: PanesShown == item.Name }"><font-awesome-icon :icon="[item.IconPrefix, item.Icon]" /> {{item.Label}}</b-nav-item>
                                <!--Has Dropdown-->
                                <b-nav-item v-if="Object.keys(item.DropDownList).length > 0 && CheckPermission(item.Permission)" v-b-toggle="item.Name"><font-awesome-icon :icon="[item.IconPrefix, item.Icon]" /> {{item.Label}}</b-nav-item>
                                <b-collapse v-if="Object.keys(item.DropDownList).length > 0" :id="item.Name" :accordion="item.Name" role="tabpanel">
                                    <b-card no-body v-for="dropdownItem in item.DropDownList">
                                        <b-nav-item @click="CloseSlideout()" v-if="CheckPermission(dropdownItem.Permission) && dropdownItem.Name != 'Record'" v-on:click="ChangePaneShown(dropdownItem.Name)" v-bind:class="{ active: PanesShown == dropdownItem.Name }">
                                            <font-awesome-icon :icon="[dropdownItem.PrefixIcon, dropdownItem.Icon]" /> {{dropdownItem.Label}}
                                        </b-nav-item>
                                        <div v-if="dropdownItem.hasOwnProperty('Record') && Object.keys(dropdownItem.Record).length > 0 ">
                                            <b-nav-item @click="CloseSlideout()" v-for="r in dropdownItem.Record " v-bind:class="{ active: PanesShown == r.Id }">

                                                <span v-on:click="ChangePaneShown(r.Id)">

                                                    <font-awesome-icon :icon="[dropdownItem.IconPrefix, dropdownItem.Icon]" />
                                                    {{DisplayLabel(r,dropdownItem.Label)}}
                                                </span>
                                                <span style="float:right;" v-on:click="CloseRecord(dropdownItem.RemoveRecordPath,dropdownItem.ChangePaneNameAfterRecordRemoval, r.Id)">X</span>
                                            </b-nav-item>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </span>
                            <b-nav-item><Logout /></b-nav-item>
                        </b-nav>
                    </div>
                </b-col>
                <b-col id="panel" style="height:90vh;">
                    <div :style="[!IsMobile ? null : slideoutOpen() ? {'position': 'fixed', 'padding-right':'100%', 'top':'0','bottom':'0', 'z-index': '1'} : {'position': 'fixed', 'padding-right':'3vw', 'top':'0','bottom':'0', 'z-index': '1'}]"></div>
                    <div>
                        <div v-for="item in SideBarItems">
                            <div v-if="Object.keys(item.DropDownList).length < 1" v-show="PanesShown == item.Name && CheckPermission(item.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                <component :is="item.Name"></component>
                            </div>
                            <div v-else v-for="dropDownItem in item.DropDownList">
                                <div v-if="dropDownItem.hasOwnProperty('VIf')">
                                    <div v-if="PanesShown == dropDownItem.Name && CheckPermission(dropDownItem.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                        <component :is="dropDownItem.Name"></component>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-show="PanesShown == dropDownItem.Name" v-if="CheckPermission(dropDownItem.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                        <component :is="dropDownItem.Name"></component>
                                    </div>
                                </div>
                                <div v-if="dropDownItem.Name == 'Record'">
                                    <div v-for="(r,Id) in dropDownItem.Record" v-if="r.hasOwnProperty(dropDownItem.HasOwnProperty)" v-show="PanesShown == Id">
                                        <div :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                            <component :is="dropDownItem.ComponentName" v-bind:[dropDownItem.DataToPass]="r" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--Logged in User-->
        <!--<p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>-->
        <SessionTimeout :timeout-seconds="1200" />
    </div>
        
    
</template>

<script>
    //import services
    import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    import $ from 'jquery'
    import { isMobile } from 'mobile-device-detect';
    //import components
    //import FamilyPane from '../Families/FamilyPane.vue';
    import Home from "./Home.vue";
    //import components
    import ChildList from "../Children/ChildList.vue";
    import LocationList from "../Location/LocationList.vue";
    import LocationRecord from "../Location/LocationRecord/LocationRecord.vue";
    import AddNewLocation from "../Location/AddNewLocation.vue";
    import AddNewChild from "../Children/AddNewChild.vue";
    import ChildRecord from "../Children/ChildRecord/ChildRecord.vue";
    import ClientReferral from "../ClientReferral.vue";
    import Slideout from 'vue-slideout'
    import Reports from "../Reports/Reports.vue";
    import DocumentsPane from '../../Core/RecordComponents/DocumentsPane.vue';
    import UserDrafts from '../../Core/RecordComponents/UserDrafts.vue';
    import SignaturesPane from '../../Core/RecordComponents/SignaturesPane.vue';
    import GroupList from '../Groups/GroupList.vue';
    
    import DirectorEmployeeView from "../../Admin/DirectorEmployeeView.vue";
    import Logout from '../../Core/UI/Logout.vue';
    //import UsersettingsPane from '../Usersettings/UsersettingsPane.vue';
    import SessionTimeout from '../../Core/UI/SessionTimeout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    import { faBuilding } from '@fortawesome/free-solid-svg-icons';
    library.add(faBuilding);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    import { faUserGraduate } from '@fortawesome/free-solid-svg-icons';
    library.add(faUserGraduate);
    import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileAlt);
    import { faToolbox } from '@fortawesome/free-solid-svg-icons';
    library.add(faToolbox);
    import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleLeft);
    import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleRight);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faCalendarAlt);
    import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
    library.add(faDollarSign);
    import _ from 'lodash';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "TAYLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
            let vm = this;
            EventBus.$on('documents-requiring-my-signature-updated', docCount => {
                vm.DocumentsRequiringMySignature = docCount;
            });

        },
        beforeDestroy() {
            EventBus.$off('documents-requiring-my-signature-updated');
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Tay.png",
                sidebarStyle: {'display':'none'},
                innerWidth : window.innerWidth,
                SidebarWidth: 0,
                DocumentsRequiringMySignature: 0,
                PanesShown: "Home",
                //SideBarItems: [
                //    { Name: 'Home', IconPrefix: 'fa', Icon: 'home', DropDownList: [] },
                //    {
                //        Name: 'Clients', IconPrefix: 'fa', Icon: 'child',
                //        DropDownList:
                //            [{ Name: 'AddNewChild', IconPrefix: 'fa', Icon: 'plus' },
                //                { Name: 'ChildList', IconPrefix: 'fa', Icon: 'list' }]
                //    },
                //    { Name: 'Locations', IconPrefix: 'fa', Icon: 'building', 
                //       DropDownList: [{Name: 'AddNewLocation', IconPrefix: 'fa', Icon: 'plus'},
                //            { Name: 'LocationList', IconPrefix: 'fa', Icon: 'list' }]
                //    }
                //],
                EmployeePrivateProfile: {
                    UserID: "",
                    EmployeeID: "",
                    Email: "",
                    FirstName: "",
                    LastName: "",
                    AssignedSubPrograms: [],
                    Permissions: [],
                    Roles: []
                },
                CoreProgramData: {
                    CoreProgramID: "",
                    CoreProgramName: "",
                    WarningAnnouncements: [],
                    Agencies: [],
                    ScreenWidth: ""
                }
            };
        },
        methods: {
            CloseSlideout() {
                if (this.$refs.Slideout) {
                    this.$refs.Slideout.slideout.toggle();
                } 
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ChangePaneShown(paneName) {
                this.PanesShown = paneName;
                this.$nextTick(function () {
                    EventBus.$emit('profile-update-needed', paneName);
                })
                
            },
            GetEmployeePrivateProfile() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetEmployeePrivateProfile", {}, this.GetEmployeePrivateProfileSuccess, ()=>{}, true);
            },
            GetEmployeePrivateProfileSuccess(response) {
                let vm = this;
                response.data.data.AssignedSubPrograms = response.data.data.AssignedSubPrograms.filter(sp => sp.CoreProgram.Name == "TAY");
                vm.$store.commit("User.PrivateProfile.Replace", response.data.data);
            },
            CloseRecord: function (path,paneName,Id) {
                if (this.PanesShown == Id) {
                    this.ChangePaneShown(paneName);
                }
                this.$store.commit(path, Id);
                this.$nextTick(function () {
                    EventBus.$emit('profile-update-needed', this.PanesShown);
                });
                
            },
            CloseLocationRecord: function (spmID) {
                if (this.PanesShown == spmID) {
                    this.ChangePaneShown("Locations");
                }
                this.$store.commit("Residences.ResidenceProfiles.Remove", spmID);
                
            },
            CloseLocationRecord: function (locationID) {
                if (this.PanesShown == locationID) {
                    this.ChangePaneShown("Locations");
                }
                this.$store.commit("Residences.ResidenceProfiles.Remove", locationID);

                this.$store.commit(path, Id);
            },
            DisplayLabel(obj,path) {
                return _.get(obj, path);
            },
            slideoutOpen() {
                if (this.$refs.Slideout) {
                    return this.$refs.Slideout.slideout.isOpen();
                }
            },
            HamburgerMenuDesktop() {
                if (this.$refs.sidebarColumn.style.display == 'block') {
                    this.$refs.sidebarColumn.style.display = 'none';
                }
                else {
                    this.$refs.sidebarColumn.style.display = 'block';
                }
                
            },
        },
        components: {
            Home,
            //FamilyPane,
            //UsersettingsPane,
            Logout,
            SessionTimeout,
            ChildList,
            ClientReferral,
            AddNewChild,
            ChildRecord,
            Slideout,
            LocationList,
            AddNewLocation,
            LocationRecord,
            DirectorEmployeeView,
            DocumentsPane,
            UserDrafts,
            Reports,
            SignaturesPane,
            GroupList
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            OpenChildRecords() {
                return this.$store.state.Clients.ClientProfiles;
            },
            OpenLocationRecords() {
                return this.$store.state.Residences.ResidenceProfiles;
            },
            IsMobile: function () {
                return isMobile;
            },
            SideBarItems: function () {
                let obj = {};
                obj["Home"] = {
                    Name: 'Home',
                    Label: 'Home',
                    IconPrefix: 'fa',
                    Icon: 'home',
                    DropDownList: [],
                    Permission: ''
                }
                obj["Clients"] = {
                    Name: 'Clients',
                    Label: 'Clients',
                    IconPrefix: 'fa',
                    Icon: 'child',
                    Permission: ''
                };
                obj["Clients"]["DropDownList"] = {};
                obj["Clients"]["DropDownList"]["0"] = {
                    Name: 'AddNewChild',
                    Label: 'Add Child',
                    IconPrefix: 'fa',
                    Icon: 'plus',
                    Permission: 'Navigation_AddChild'
                };
                obj["Clients"]["DropDownList"]["1"] = {
                    Name: 'ClientReferral',
                    Label: 'Client Referral',
                    IconPrefix: 'fa',
                    Icon: 'comments',
                    Permission: 'Navigation_ClientReferral'
                };
                obj["Clients"]["DropDownList"]["2"] = {
                    Name: 'ChildList',
                    Label: 'List',
                    IconPrefix: 'fa',
                    Icon: 'list',
                    Permission: 'Navigation_ChildList'
                };
                obj["Clients"]["DropDownList"]["Record"] ={
                    Name: "Record",
                    Record: this.OpenChildRecords,
                    IconPrefix: 'fa',
                    Icon: 'child',
                    HasOwnProperty: 'Client',
                    Label: 'Client.Person.FirstNameLastInitial',
                    ComponentName: "ChildRecord",
                    DataToPass: "child-record-data",
                    RemoveRecordPath: "Clients.ClientProfiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "ChildList",
                    Permission: ''
                }
                obj["Location"] = {
                    Name: 'Locations',
                    Label: 'Locations',
                    IconPrefix: 'fa',
                    Icon: 'building',
                    Permission: ''
                };
                obj["Location"]["DropDownList"] = {};
                obj["Location"]["DropDownList"]["0"] = {
                    Name: 'AddNewLocation',
                    Label: 'Add New Location',
                    IconPrefix: 'fa',
                    Icon: 'plus',
                    Permission: 'TAY.Navigation_AddNewTeam'
                };
                obj["Location"]["DropDownList"]["1"] = {
                    Name: 'LocationList',
                    Label: 'List',
                    IconPrefix: 'fa',
                    Icon: 'list',
                    Permission: 'TAY.Navigation_LocationList'
                };
                obj["Location"]["DropDownList"]["Record"] = {
                    Name: "Record",
                    Record: this.OpenLocationRecords,
                    IconPrefix: 'fa',
                    Icon: 'building',
                    HasOwnProperty: 'Id',
                    Label: 'Name',
                    ComponentName: "LocationRecord",
                    DataToPass: "location-record-data",
                    RemoveRecordPath: "Residences.ResidenceProfiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "LocationList",
                    Permission: ''
                }
                obj["Documents"] = {
                    Name: 'Documents',
                    Label: 'Documents',
                    IconPrefix: 'fa',
                    Icon: 'file-alt',
                    Permission: ''
                };
                obj["Documents"]["DropDownList"] = {};
                obj["Documents"]["DropDownList"]["0"] = {
                    Name: 'UserDrafts',
                    Label: 'Drafts',
                    IconPrefix: 'fa',
                    Icon: 'edit',
                    Permission: 'Navigation_Drafts'
                };
                obj["Documents"]["DropDownList"]["1"] = {
                    Name: 'SignaturesPane',
                    Label: 'Signatures',
                    IconPrefix: 'fa',
                    Icon: 'signature',
                    Permission: 'Navigation_Signatures'
                };
                obj["Reports"] = {
                    Name: 'Reports',
                    Label: 'Reports',
                    IconPrefix: 'fa',
                    Icon: 'chart-bar',
                    DropDownList: [],
                    Permission: 'Navigation_Reports'
                };
                obj["DirectorEmployeeView"] = {
                    Name: 'DirectorEmployeeView',
                    Label: 'Employees',
                    IconPrefix: 'fa',
                    Icon: 'users',
                    DropDownList: [],
                    Permission: 'Navigation_Employees'
                };
                obj["GroupList"] = {
                    Name: 'GroupList',
                    Label: 'Groups',
                    IconPrefix: 'fa',
                    Icon: 'user-graduate',
                    DropDownList: [],
                    Permission: 'Navigation_Groups'
                };
                return obj;
            }
        },
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
        z-index: 2;
    }
    .ExpandButtons{
        width:100%;
        height:100%;    
        /*margin-top:1rem;*/
        color:black;
        padding-bottom:1rem;
    }
    .content{
        position:absolute;
        width: 98%; /*stop page scroll*/
        min-height:100%;
    }
    .sidebarSmallButtons > *{
        padding:0;
        text-align:center;
    }
    /*li.active a {
        color: white;
    }*/
      .slideout-menu {
    top: 0;
    bottom: 0;
    width: 75vw;
    height: 100vh;
    overflow-y: scroll;
    /*-webkit-overflow-scrolling: touch;*/
     
    z-index: 1;
    display: none;
    background-color:white;
    /*background-color: #1D1F20;
    color: white;*/
  }

  .slideout-menu-left {
    left: 0;
  }

  .slideout-menu-right {
    right: 0;
  }

  .slideout-panel {
    /*background-color: #4B5;
    color: white;*/
    touch-action: pan-y;
    position: relative;
    z-index: 1;
    /*will-change: transform;*/
  }

  .slideout-open,
  .slideout-open body,
  .slideout-open .slideout-panel {
      position: fixed;
    overflow: hidden;
  }

  .slideout-open .slideout-menu {
    display: block;
  }
  .mobile-name-style{
      height:64px; 
      border-bottom-color:black;
      border-bottom-width:thin;
      border-bottom:double; 
      justify-content:center;
      font-size:x-large;
      font-weight:bold;
      display:flex;
      align-items:center;
  }
  .display-none{
      display: none;
  }
  .slideout-left-menu{
      height:100%;
      width:60vw;
      background-color:white;
  }
    @media screen and (max-width: 990px){
     /* CSS that should be displayed if width is equal to or less than 991px goes here */
     #navbar-brand{
         position:relative;
         right:1rem;
         margin-left:auto;
     }
     #HamburgerMenuDesktop{
         display:block;
     }

    }
    @media screen and (min-width: 991px){
     /* CSS that should be displayed if width is equal to or less than 991px goes here */
        #navbar-brand{
            position:relative;
        }
        #HamburgerMenuDesktop{
            display:none;
        }
        #sideBarID{
            display:block !important;
        }
    }

    .TAYLayout {
        background-color: #605271;
    }
</style>